export default __webpack_public_path__ + "e0ff5bcc63799603216bf92feb80b369.svg";